// GLASS — soft two-column glass cards. Frosted, softly-tinted cards in a
// responsive auto-fit grid sitting on an accent-tinted gradient wrapper.
// Cards expand in place (accordion) with a staggered entrance reveal.
//  - wrapper radius: 1.8x base (ctx.v.radiusWrap); card radius: 1.3x (ctx.v.radiusCard)
//  - glass gradient/backgrounds depend on light vs dark → cssDark overrides
function itemHtml(ctx, it, i) {
    return `<div class="fq-acc"${ctx.reveal(i)}>
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    ${ctx.showIcon ? `<span class="fq-badge">${ctx.icon}</span>` : ''}
    <span class="fq-q">${it.q}</span>
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const glass = {
    id: 'glass',
    name: 'Glass',
    tag: 'Two-column cards',
    styleTag: 'Soft glass',
    description: 'Frosted, softly-tinted cards in a responsive two-column grid. Each card expands in place with a plus-morph icon and a staggered entrance reveal. Feels premium without trying hard.',
    layout: 'cards',
    defaultAccent: '#7c3aed',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion', 'reveal'],
    render(ctx) {
        const a = ctx.tokens.accent;
        const wrapBgLight = `linear-gradient(150deg, ${ctx.rgba(a, 0.1)}, rgba(255,255,255,0.6) 55%, ${ctx.rgba(a, 0.07)})`;
        const wrapBgDark = `linear-gradient(150deg, ${ctx.rgba(a, 0.16)}, rgba(255,255,255,0.03) 55%, ${ctx.rgba(a, 0.1)})`;
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-grid">
${ctx.items.map((it, i) => itemHtml(ctx, it, i)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:880px;margin:0 auto;padding:40px 32px 48px;border-radius:${ctx.v.radiusWrap};background:${wrapBgLight}}
.FQM .fq-head{text-align:center;max-width:520px;margin:0 auto 32px}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:34px;font-weight:650;line-height:1.1;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:16px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:14px;align-items:start}
.FQM .fq-acc{background:rgba(255,255,255,0.62);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,0.75);border-radius:${ctx.v.radiusCard};box-shadow:0 6px 24px rgba(15,30,60,0.06)}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;gap:14px;padding:18px 20px}
.FQM .fq-badge{flex:0 0 auto;display:grid;place-items:center;width:30px;height:30px;border-radius:999px;background:${ctx.v.soft}}
.FQM .fq-badge .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-q{font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-a{padding:0 20px 18px 64px;font-size:15px;line-height:1.65;color:${ctx.v.sub}}
`;
        const cssDark = `
.FQM .fq-wrap{background:${wrapBgDark}}
.FQM .fq-acc{background:rgba(255,255,255,0.07);border-color:rgba(255,255,255,0.16)}
`;
        return { html, css, cssDark };
    },
};
export default glass;
